export const CONTENT = 'CONTENT';
export const STYLE = 'STYLE';
export const DATA = 'DATA';
export const VISIBILITYGROUP = 'visibilityGroup';
export const EDIT = 'edit';